export const dispatchNotProcessed = {
    columns: [
        {
            title: 'Despacho',
            name: 'dispatchId',
            type: 'string',
            editable: false,
            align: 'center',
            value: (element: any) => element.dispatchId
        },
        {
            title: 'SKU',
            name: 'skuCode',
            type: 'string',
            editable: false,
            align: 'center',
            value: (element: any) => element.skuCode + '-' + element.skuPartialSequence 
        },
        {
            title: 'Estado',
            name: 'state',
            type: 'string',
            editable: false,
            align: 'center',
            value: (element: any) => element.state
        }
    ]
}